import { axiosAPIInstance as axios } from '../../axios-config';

const internalSimplifyMap = new Map();
function jsonSimplifyFunc(keyNameUnused, val) {
  if (internalSimplifyMap.has(val)) return '[nested object]';

  if (!val) return val;
  if (val.$vue || val.$refs || val.props || (val.data && val.data.$route)) return undefined;

  if (!Array.isArray(val) && val.forEach) {
    const res = {};
    val.forEach((v, k) => {
      res[k] = v;
    });
    return res;
  }

  if (val instanceof Map) {
    const res = {};
    val.forEach((v, k) => {
      res[k] = v;
    });
    return res;
  }

  if (typeof val === 'object') {
    internalSimplifyMap.set(val, true);
  }
  return val;
}

const actions = {
  async createSupportTicket({ rootState, getters }, { subject, description, imageUrl, contactEmail, externalSource, externalId, }) {
    internalSimplifyMap.clear();
    // TODO: add console cache
    const state = rootState;
    state.userAgent = navigator.userAgent;
    state.vendor = navigator.vendor;
    const uaData = navigator.userAgentData;
    state.userAgentData = (uaData && uaData.toJSON) ? uaData.toJSON() : {};
    const ticket = {
      subject,
      description,
      imageUrl,
      vuex: JSON.stringify(state, jsonSimplifyFunc),
      url: location.href,
      contactEmail,
      externalSource,
      externalId,
    };
    const response = (getters.me.email)
      ? await axios.post('/blade/support-tickets', ticket)
      : await axios.post('/blade/support-tickets/nouser', ticket);
    return response.data.ticket;
  },
  async getSupportTickets() {
    const response = await axios.get('/blade/support-tickets');
    return response.data.tickets;
  },
  async getSupportTicket(_, { ticketId }) {
    const { data } = await axios.get(`/blade/support-tickets/${ticketId}`);
    return data;
  },
  async getSupportTicketTypes({ dispatch }) {
    return dispatch('getSupportTicket', { ticketId: 'types' });
  },
  async updateSupportTicket(_, metric) {
    const response = await axios.patch(`/blade/support-tickets/${metric._id}`, metric);
    return response.data.metric;
  },
  async deleteSupportTicket(_, { ticketId, _id }) {
    const did = ticketId || _id;
    const response = await axios.delete(`/blade/support-tickets/${did}`);
    return response.data.metric;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/support-tickets.js